







































































































































import { defineComponent, ref } from '@vue/composition-api';
import moment from 'moment';
import { IMandatoryItem } from '@/models';
import {
  useFetchTariffMandatoryItems,
  useDeleteTariffMandatoryItem
} from '@/composable/tariff-mandatory-item';
import authMixin from '@/mixins/auth';

import ALPage from '@/components/core/Page/ALPage.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import TariffMandatoryItemFormDialog from '@/components/tariff/TariffMandatoryItemFormDialog.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';

export default defineComponent({
  name: 'TariffMandatoryItemListPage',
  mixins: [authMixin],
  components: {
    ALPage,
    ConfirmationDialog,
    ErrorAlert,
    TariffMandatoryItemFormDialog
  },
  setup(_) {
    //We use a separate ref for the search model in order to not update the queryKey once the search is updated
    const currentSearch = ref<string>('');

    const headers = [
      { text: '#', value: 'index', sortable: false, width: 5 },
      { text: 'Item', value: 'item', sortable: false },
      { text: '', value: 'actions', sortable: false, width: 100 }
    ];

    const dialog = ref(false);
    const selectedTariffMandatoryItem = ref<IMandatoryItem | null>(null);

    function openTariffMandatoryItemDialog(
      tariffMandatoryItem?: IMandatoryItem
    ) {
      dialog.value = true;
      selectedTariffMandatoryItem.value = tariffMandatoryItem ?? null;
    }

    const {
      isLoading: deleteInProgress,
      error: deleteError,
      mutate: deleteTariffMandatoryItem,
      reset: deleteReset
    } = useDeleteTariffMandatoryItem();

    const deleteDialog = ref(false);
    function openDeleteTariffMandatoryItemDialog(
      tariffMandatoryItem: IMandatoryItem
    ) {
      selectedTariffMandatoryItem.value = tariffMandatoryItem;
      deleteDialog.value = true;
    }

    function closeDialog() {
      deleteDialog.value = false;
    }

    function removeTariffMandatoryItem(tariffMandatoryItem: IMandatoryItem) {
      deleteTariffMandatoryItem(tariffMandatoryItem.id!, {
        onSuccess: () => {
          closeDialog();
        }
      });
    }

    function clearAllErrors() {
      deleteReset();
      error.value = null;
    }

    const {
      tariffMandatoryItems,
      error,
      isLoading
    } = useFetchTariffMandatoryItems();

    return {
      deleteInProgress,
      deleteDialog,
      deleteError,
      selectedTariffMandatoryItem,
      moment,
      dialog,
      currentSearch,
      tariffMandatoryItems,
      isLoading,
      headers,
      error,
      openTariffMandatoryItemDialog,
      clearAllErrors,
      openDeleteTariffMandatoryItemDialog,
      closeDialog,
      removeTariffMandatoryItem
    };
  }
});
